import React from "react";
import { FaUserPlus, FaBell, FaBoxOpen, FaMoneyCheckAlt } from "react-icons/fa";

export default function DriverTimeline() {
  const driverSteps = [
    {
      id: 1,
      title: "Sign Up in Minutes",
      icon: <FaUserPlus />,
      disc: "Fill out our online application here, and we’ll get you verified quickly.",
    },
    {
      id: 2,
      title: "Get Job Offers",
      icon: <FaBell />,
      disc: "Once approved, you’ll receive job notifications in the Tuber Driver app. Accept deliveries that fit your schedule.",
    },
    {
      id: 3,
      title: "Pick Up & Deliver",
      icon: <FaBoxOpen />,
      disc: "Head to the assigned trade store, collect the order, and drop it off at the designated site. It’s that easy.",
    },
    {
      id: 4,
      title: "Get Paid Weekly",
      icon: <FaMoneyCheckAlt />,
      disc: "Payments are made directly to your bank account every week. The more you deliver, the more you earn!",
    },
  ];

  return (
    <div className="px-5 py-16 max-w-4xl mx-auto">
      <h1 className="text-3xl md:text-4xl font-bold text-center mb-10 md:mb-16 text-headings">
        How It Works
      </h1>

      {/* Timeline */}
      <div className="relative">
        {/* Vertical timeline bar */}
        <div className="absolute left-0 md:left-1/2 transform -translate-x-1/2 h-full w-1 bg-primary opacity-20"></div>

        {/* Timeline steps */}
        {driverSteps.map((step) => (
          <div
            key={step.id}
            className="flex pb-10 md:pb-16 timeline pl-6 md:pl-0 flex-col md:flex-row"
          >
            {/* Left content */}
            <div className="md:w-5/12 text-left">
              <span className="text-sm font-bold text-btn_hover uppercase">{`Step 0${step.id}`}</span>
              <h3 className="text-lg md:text-xl font-semibold text-headings">
                {step.title}
              </h3>
            </div>

            {/* Center dot */}
            <div className="w-[17%] flex justify-start md:justify-center absolute md:relative -left-3 md:left-auto">
              <div className="w-6 h-6 rounded-full bg-primary z-40"></div>
            </div>

            {/* Right content */}
            <div className="md:w-5/12 flex gap-2 md:gap-3 mt-2 md:mt-0">
              <div className="h-10 flex items-center justify-center text-primary text-2xl md:text-3xl">
                {step.icon}
              </div>

              <p className="flex-1 text-sm md:text-lg font-medium text-light_black pt-1">
                {step.disc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
